import React, { useState } from 'react'
import Modal from '../common/Modal'
import { handlePostRequest } from '../../utils/api-handler.util'
import { showToaster } from '../../utils/show-toaster.util'
import { reportReasons } from '../../constants/reportReasons'
import { useMutation } from '@tanstack/react-query'
import LoadingIcon from '../icons/LoadingIcon'
import { useAuth } from '../../contexts/AuthContext'
import SelectField from './SelectField'
import TextareaField from './TextareaField'

const ReportModal = ({ isOpen, onClose, reportTarget, contentId, contentType }) => {
  const [selectedReason, setSelectedReason] = useState('')
  const [customReason, setCustomReason] = useState('')
  const { currentUser } = useAuth()

  const createReportMutation = useMutation({
    mutationFn: async ({ reportReason, contentId, contentType }) => {
      return handlePostRequest(`/${currentUser.userType}s/report-content`, {
        reportReason,
        contentId,
        contentType,
      })
    },
    onSuccess: () => {
      showToaster('success', 'Report submitted successfully')
      onClose()
    },
  })

  const handleReportSubmit = async () => {
    const reportReason = selectedReason === reportReasons.OTHER ? customReason : selectedReason
    await createReportMutation.mutateAsync({
      reportReason,
      contentId,
      contentType,
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center text-center ">
        <h2 className="text-xl font-bold">
          <span>Report {reportTarget}</span>
        </h2>

        <p className="text-sm text-gray-600 max-w-md">
          Are you sure you want to report this {contentType?.split('_').join(' ')}? This will notify
          the admin.
        </p>

        <div className="w-3/4 mt-4 mb-4">
          <label className="block text-sm text-left font-medium text-gray-700 mb-1">
            Reason for reporting
          </label>
          <SelectField value={selectedReason} onChange={(e) => setSelectedReason(e.target.value)}>
            <option value="">Select a reason</option>
            {Object.values(reportReasons).map((reason) => (
              <option key={reason} value={reason}>
                {reason}
              </option>
            ))}
          </SelectField>
        </div>

        {selectedReason === reportReasons.OTHER && (
          <div className="w-3/4">
            <TextareaField
              label={'Specify your reason'}
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
            />
          </div>
        )}
      </div>

      <div className="flex justify-center gap-4 mt-4 w-full">
        <button
          onClick={onClose}
          className="px-5 py-2 bg-neutral-200 text-gray-700 rounded hover:bg-neutral-200"
        >
          Cancel
        </button>
        <button
          type="submit"
          onClick={handleReportSubmit}
          className="px-5 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          disabled={createReportMutation.isLoading}
        >
          {createReportMutation.isLoading ? (
            <>
              <LoadingIcon />
              Reporting...
            </>
          ) : (
            'Report'
          )}
        </button>
      </div>
    </Modal>
  )
}

export default ReportModal
